import { ActiveInsuranceGroup } from "./active-insurance-group";
import { Policy } from "./policy";

export class GroupWithPolicies extends ActiveInsuranceGroup {
  count?: number;
  cols?: number;
  policies: Policy[];

  constructor(group: ActiveInsuranceGroup) {
    super();
    this.position = group.position;
    this.name = group.name;
    this.lobIds = group.lobIds;
    this.icon = group.icon;
  }
}
